export function MissingHookMessage({ loginUrl }: { loginUrl: string }) {
  return (
    <div className="p42-center">
      <h2>Please complete the following steps to order business cards via the SAP SRM system:</h2>
      <br />
      <ul>
        <li>1) Log in to the SRM portal</li>
        <li>2) Click on "Einkaufen" to see all shops</li>
        <li>3) Select "Visitenkarten Linde Brandportal" (= business cards)</li>
      </ul>
      <br />
      <a href={loginUrl} className="c-button c-button--dark" target="_blank" rel="noreferrer">
        Log in to SRM portal
      </a>
    </div>
  );
}
